import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerProvider } from "@/context/CustomerContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { initTracking } from "@/lib/tracking";
import { StoreLayout } from "@/components/store/StoreLayout";
import { MaintenanceGate } from "@/components/store/Maintenance";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import MyOrdersPage from "@/pages/MyOrdersPage";
import AccountPage from "@/pages/AccountPage";
import NotFoundPage from "@/pages/NotFoundPage";
import InfoPage from "@/pages/InfoPage";
import AssistenciaPage from "@/pages/AssistenciaPage";
import CatalogoPage from "@/pages/CatalogoPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminBanners from "@/pages/admin/AdminBanners";
import AdminDelivery from "@/pages/admin/AdminDelivery";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminPages from "@/pages/admin/AdminPages";
import AdminSeo from "@/pages/admin/AdminSeo";
import AdminHomeEditor from "@/pages/admin/AdminHomeEditor";
import AdminMarketing from "@/pages/admin/AdminMarketing";

function App() {
  useEffect(() => {
    initTracking();
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
          <CartProvider>
          <CustomerProvider>
            <Routes>
              {/* Loja (com portão do Modo Manutenção) */}
              <Route element={<MaintenanceGate />}>
                <Route element={<StoreLayout />}>
                  <Route index element={<HomePage />} />
                  <Route path="/produtos" element={<CatalogPage />} />
                  <Route path="/categoria/:slug" element={<CatalogPage />} />
                  <Route path="/produto/:id" element={<ProductPage />} />
                  <Route path="/carrinho" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/acompanhar" element={<TrackOrderPage />} />
                  <Route path="/pedidos" element={<MyOrdersPage />} />
                  <Route path="/conta" element={<AccountPage />} />
                  <Route path="/pagina/:slug" element={<InfoPage />} />
                  <Route path="/assistencia" element={<AssistenciaPage />} />
                  <Route path="/catalogo" element={<CatalogoPage />} />
                  <Route path="/colecao/:slug" element={<CatalogoPage />} />
                  {/* 404 da loja */}
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Route>

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="produtos" element={<AdminProducts />} />
                <Route path="categorias" element={<AdminCategories />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="entregas" element={<AdminDelivery />} />
                <Route path="pagamentos" element={<AdminPayments />} />
                <Route path="pedidos" element={<AdminOrders />} />
                <Route path="notificacoes" element={<AdminNotifications />} />
                <Route path="avaliacoes" element={<AdminReviews />} />
                <Route path="clientes" element={<AdminCustomers />} />
                <Route path="paginas" element={<AdminPages />} />
                <Route path="seo" element={<AdminSeo />} />
                <Route path="home" element={<AdminHomeEditor />} />
                <Route path="marketing" element={<AdminMarketing />} />
                <Route path="configuracoes" element={<AdminSettings />} />
              </Route>
            </Routes>
            <Toaster richColors position="top-center" />
          </CustomerProvider>
          </CartProvider>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
